import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "border border-(--border-border-base-medium) rounded-(--border-border-radius-rounded-l) p-4 flex items-center gap-6" };
const _hoisted_2 = { class: "flex-1 min-w-0 flex flex-col gap-3" };
const _hoisted_3 = { class: "text-base font-medium text-(--text-text-body) truncate" };
const _hoisted_4 = { class: "flex flex-col gap-1.5" };
const _hoisted_5 = { class: "flex items-center gap-3 shrink-0" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { RouterLink } from "vue-router";
import { Avatar, Button, Dropdown, Tooltip } from "@eudonet/opal";
import { usePermissions } from "@/shared/composables/usePermissions";
import ContactRelationFunctionRow from "./ContactRelationFunctionRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactRelationOrgCard',
    props: {
        organisation: {}
    },
    emits: ["edit-relation", "delete-relation"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        const { canEditOphub: canEdit, disabledTooltip } = usePermissions();
        const moreItems = computed(() => [
            {
                label: t("common.delete"),
                icon: "ri-delete-bin-line",
                danger: true,
                onClick: () => emit("delete-relation"),
            },
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(RouterLink), {
                        to: { name: 'Organisation', params: { id: __props.organisation.id } },
                        class: "flex items-center gap-2 min-w-0 hover:opacity-80 transition-opacity"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Avatar), {
                                img: __props.organisation.logoUrl ?? undefined,
                                name: __props.organisation.name,
                                size: "md",
                                entity: "organisation",
                                logo: "",
                                presentational: ""
                            }, null, 8 /* PROPS */, ["img", "name"]),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.organisation.name), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"]),
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.organisation.functions, (fn) => {
                            return (_openBlock(), _createBlock(ContactRelationFunctionRow, {
                                key: fn.id,
                                fn: fn
                            }, null, 8 /* PROPS */, ["fn"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(Tooltip), {
                        text: _unref(disabledTooltip),
                        disabled: _unref(canEdit),
                        tabindex: !_unref(canEdit) ? 0 : undefined
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Button), {
                                variant: "secondary",
                                size: "sm",
                                "icon-only": "",
                                "icon-left": "ri-pencil-line",
                                "aria-label": _ctx.$t('common.edit'),
                                disabled: !_unref(canEdit),
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('edit-relation')))
                            }, null, 8 /* PROPS */, ["aria-label", "disabled"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["text", "disabled", "tabindex"]),
                    _createVNode(_unref(Tooltip), {
                        text: _unref(disabledTooltip),
                        disabled: _unref(canEdit),
                        tabindex: !_unref(canEdit) ? 0 : undefined
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Dropdown), { items: moreItems.value }, {
                                trigger: _withCtx(({ triggerProps }) => [
                                    _createVNode(_unref(Button), _mergeProps(triggerProps, {
                                        variant: "secondary",
                                        size: "sm",
                                        "icon-only": "",
                                        "icon-left": "ri-more-fill",
                                        "aria-label": _ctx.$t('common.moreActions'),
                                        disabled: !_unref(canEdit)
                                    }), null, 16 /* FULL_PROPS */, ["aria-label", "disabled"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["items"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["text", "disabled", "tabindex"])
                ])
            ]));
        };
    }
});
